import React from "react";
import {Container} from "@chakra-ui/react";
import Advantage from "../components/Advantage";

function Listen(props) {
    return (
        <Container maxW={"7xl"} paddingX={8}>
            <Advantage/>
            <Advantage/>
            <Advantage/>
            <Advantage/>
            <Advantage/>
        </Container>
    );
}

export default Listen;
